import { render, staticRenderFns } from "./preview-whatsapp-template.vue?vue&type=template&id=1ad50c64&scoped=true"
import script from "./preview-whatsapp-template.vue?vue&type=script&lang=js"
export * from "./preview-whatsapp-template.vue?vue&type=script&lang=js"
import style0 from "./preview-whatsapp-template.vue?vue&type=style&index=0&id=1ad50c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad50c64",
  null
  
)

export default component.exports